import request from "@/utils/request";
const { ElMessage } = require("element-plus");

export default {
  name: "RoomStatus",
  data() {
    return {
      loading: true,
      roomDialogVisible: false,
      filterBuild: "",
      filterFloor: "",
      filterType: "",
      allRooms: [],
      filteredRooms: [],
      buildOptions: [],
      floorOptions: [],
      statistics: {},
      roomForm: {
        dormRoomId: "",
        dormBuildId: "",
        floorNum: "",
        roomType: "",
        roomColor: "",
        problemNote: "",
        maxCapacity: 4,
        currentCapacity: 0
      },
      roomBeds: [],
      typeOptions: [
        { label: "正常/空房", value: "normal" },
        { label: "问题房", value: "problem" },
        { label: "值班室", value: "duty" },
        { label: "布草间", value: "linen" },
        { label: "洗衣房", value: "laundry" },
        { label: "教师收菜房", value: "teacher" },
        { label: "会议室", value: "meeting" },
        { label: "套房", value: "suite" }
      ],
      typeLabelMap: {
        normal: "正常/空房",
        problem: "问题房",
        duty: "值班室",
        linen: "布草间",
        laundry: "洗衣房",
        teacher: "教师收菜房",
        meeting: "会议室",
        suite: "套房"
      },
      colorLegend: [
        { label: "问题房", color: "#F56C6C" },
        { label: "值班室", color: "#E6A23C" },
        { label: "布草间", color: "#409EFF" },
        { label: "洗衣房", color: "#67C23A" },
        { label: "教师收菜房", color: "#8e44ad" },
        { label: "会议室", color: "#909399" },
        { label: "套房", color: "#FF69B4" },
        { label: "正常/空房", color: "#ffffff" }
      ]
    };
  },
  computed: {
    groupedRooms() {
      const groups = {};
      this.filteredRooms.forEach(room => {
        const buildId = room.dormBuildId || "未知";
        const floorNum = room.floorNum || "未知";
        if (!groups[buildId]) {
          groups[buildId] = { buildId, floors: {} };
        }
        if (!groups[buildId].floors[floorNum]) {
          groups[buildId].floors[floorNum] = { floorNum, rooms: [] };
        }
        groups[buildId].floors[floorNum].rooms.push(room);
      });
      return Object.values(groups).map(build => ({
        ...build,
        floors: Object.values(build.floors).sort((a, b) => a.floorNum - b.floorNum)
      })).sort((a, b) => a.buildId - b.buildId);
    }
  },
  created() {
    this.load();
    this.loadStatistics();
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  methods: {
    async load() {
      this.loading = true;
      request.get("/room/find", {
        params: {
          pageNum: 1,
          pageSize: 1000,
          search: "",
          dormBuildId: ""
        }
      }).then((res) => {
        if (res.code === "0") {
          let records = res.data.records || res.data || [];
          // 补充显示字段
          records = records.map(room => {
            return {
              ...room,
              typeLabel: this.typeLabelMap[room.roomType] || "正常/空房",
              displayColor: room.roomColor || "#ffffff",
              bookingLabel: room.bookingStatus === 1 ? "已预订" : (room.currentCapacity > 0 ? "在住" : "空闲")
            };
          });
          this.allRooms = records;
          this.filteredRooms = [...this.allRooms];
          this.extractOptions();
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    extractOptions() {
      const builds = new Set();
      const floors = new Set();
      this.allRooms.forEach(room => {
        if (room.dormBuildId) builds.add(room.dormBuildId);
        if (room.floorNum) floors.add(room.floorNum);
      });
      this.buildOptions = Array.from(builds).sort((a, b) => a - b);
      this.floorOptions = Array.from(floors).sort((a, b) => a - b);
    },
    loadStatistics() {
      request.get("/room/statistics").then((res) => {
        if (res.code === "0") {
          const data = res.data;
          this.statistics = {
            todayCheckin: { label: "今日入住", value: data.todayCheckin || 0 },
            todayCheckout: { label: "今日退房", value: data.todayCheckout || 0 },
            tomorrowCheckout: { label: "明日退房", value: data.tomorrowCheckout || 0 },
            weekCheckout: { label: "本周退房", value: data.weekCheckout || 0 },
            currentStay: { label: "当前入住", value: data.currentStay || 0 }
          };
        }
      });
    },
    filterRooms() {
      this.filteredRooms = this.allRooms.filter(room => {
        let match = true;
        if (this.filterBuild && String(room.dormBuildId) !== String(this.filterBuild)) match = false;
        if (this.filterFloor && String(room.floorNum) !== String(this.filterFloor)) match = false;
        if (this.filterType && room.roomType !== this.filterType) match = false;
        return match;
      });
    },
    resetFilter() {
      this.filterBuild = "";
      this.filterFloor = "";
      this.filterType = "";
      this.filteredRooms = [...this.allRooms];
    },
    handleRoomClick(room) {
      this.roomDialogVisible = true;
      this.$nextTick(() => {
        this.roomForm = {
          dormRoomId: room.dormRoomId,
          dormBuildId: room.dormBuildId,
          floorNum: room.floorNum,
          roomType: room.roomType || "normal",
          roomColor: room.roomColor || "#ffffff",
          problemNote: room.problemNote || "",
          maxCapacity: room.maxCapacity || 4,
          currentCapacity: room.currentCapacity || 0
        };
        // 获取入住人信息
        this.loadOccupants(room.dormRoomId);
      });
    },
    async loadOccupants(roomId) {
      try {
        const res = await request.get("/room/" + roomId + "/occupants");
        if (res.code === "0") {
          this.roomBeds = res.data || [];
        } else {
          this.roomBeds = [];
        }
      } catch (e) {
        // 如果API不存在，使用房间数据中的床位字段
        const room = this.allRooms.find(r => r.dormRoomId === roomId);
        if (room) {
          this.roomBeds = [
            { bedIndex: 1, username: room.firstBed, name: room.firstBed },
            { bedIndex: 2, username: room.secondBed, name: room.secondBed },
            { bedIndex: 3, username: room.thirdBed, name: room.thirdBed },
            { bedIndex: 4, username: room.fourthBed, name: room.fourthBed }
          ];
        }
      }
    },
    cancelRoom() {
      this.roomDialogVisible = false;
    },
    saveRoom() {
      const promises = [];
      if (this.roomForm.roomType) {
        promises.push(request.put("/room/type/" + this.roomForm.dormRoomId, null, {
          params: { roomType: this.roomForm.roomType, problemNote: this.roomForm.problemNote || "" }
        }));
      }
      if (this.roomForm.roomColor) {
        promises.push(request.put("/room/color/" + this.roomForm.dormRoomId, null, {
          params: { roomColor: this.roomForm.roomColor }
        }));
      }
      Promise.all(promises).then(() => {
        ElMessage({ message: "保存成功", type: "success" });
        this.roomDialogVisible = false;
        this.load();
      }).catch(() => {
        ElMessage({ message: "保存失败", type: "error" });
      });
    },
    handleTypeChange(val) {
      const typeColorMap = {
        normal: "#ffffff",
        problem: "#F56C6C",
        duty: "#E6A23C",
        linen: "#409EFF",
        laundry: "#67C23A",
        teacher: "#8e44ad",
        meeting: "#909399",
        suite: "#FF69B4"
      };
      this.roomForm.roomColor = typeColorMap[val] || "#ffffff";
    },
    handleColorChange(val) {
      const colorTypeMap = {
        "#F56C6C": "problem",
        "#E6A23C": "duty",
        "#409EFF": "linen",
        "#67C23A": "laundry",
        "#8e44ad": "teacher",
        "#909399": "meeting",
        "#FF69B4": "suite"
      };
      if (colorTypeMap[val]) {
        this.roomForm.roomType = colorTypeMap[val];
      } else {
        this.roomForm.roomType = "normal";
      }
    }
  }
};
